// Brooke & Belle redesign cart helper. Same code as the Smart Cart copy's Ready callback.
// Runs only when the redesign Smart Cart (its CSS has .bb-steps) is the cart on the page.
(function () {
  function go() {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    var css = sc && sc.settings && sc.settings.custom_css || '';
    if (css.indexOf('bb-steps') === -1) return false;

    // ===== Brooke & Belle redesign cart (Smart Cart copy 37284) =====
    (function () {
      if (window.__bbCart) return; window.__bbCart = true;
      var CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var LOCK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
      var SHIELD = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E211B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>';
      var GIFT = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E211B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8c-2-4-6-4-6-1.5S10 8 12 8zM12 8c2-4 6-4 6-1.5S14 8 12 8z"/></svg>';
      function num(t) { var n = parseFloat(String(t || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
      function money(n) { return '$' + n.toFixed(2); }
      function shortName(t) {
        return t.replace(/,? Honey Colored Print T-Shirt$/, '').replace(/ (Fall )?Colored Print (T-Shirt|Long Sleeves|Sweatshirt)$/, '').replace(/ (Fall )?(T-Shirt|Long Sleeves|Sweatshirt)$/, '').trim();
      }
      function garment(t) { return /Long Sleeves?/i.test(t) ? 'Long Sleeve' : (/T-Shirt/i.test(t) ? 'T-Shirt' : (/Sweatshirt/i.test(t) ? 'Sweatshirt' : '')); }
      var busy = false;
      function apply() {
        var root = document.getElementById('rebuy-cart');
        if (!root || busy) return; busy = true;
        try {
          var items = root.querySelectorAll('.rebuy-cart__flyout-item');
          var count = 0, sizes = {};
          var rcart = null; try { rcart = window.Rebuy && Rebuy.Cart && Rebuy.Cart.getCart && Rebuy.Cart.getCart(); } catch (e) {}
          var citems = rcart && rcart.items && rcart.items.length === items.length ? rcart.items : null;
          items.forEach(function (li, idx) {
            var q = li.querySelector('.rebuy-cart__flyout-item-quantity-widget-label');
            var qty = q ? parseInt(q.textContent.replace(/\D/g, ''), 10) || 1 : 1; count += qty;
            var a = li.querySelector('.rebuy-cart__flyout-item-product-title');
            if (a && !a.dataset.bbFull) { a.dataset.bbFull = a.textContent.trim(); }
            // line price = what this line really costs (qty 2 shows the price for 2, not for 1)
            var pr = li.querySelector('.rebuy-cart__flyout-item-price');
            var ci = citems ? citems[idx] : null;
            if (ci && a && a.dataset.bbFull && ci.product_title && a.dataset.bbFull.indexOf(ci.product_title) === -1 && ci.product_title.indexOf(a.dataset.bbFull) === -1) ci = null;
            if (pr) {
              var lp = pr.querySelector('.bb-lp');
              if (ci) {
                var cmpEl = pr.querySelector('.rebuy-money.compare-at');
                var line = Math.min(ci.line_price, ci.final_line_price) / 100;
                var wasEach = cmpEl ? num(cmpEl.textContent) : 0;
                var html = '<b>' + money(line) + '</b>' + (wasEach * qty > line ? '<s>' + money(wasEach * qty) + '</s>' : '') + (qty > 1 ? '<span>for ' + qty + '</span>' : '');
                if (!lp) { lp = document.createElement('div'); lp.className = 'bb-lp'; pr.appendChild(lp); }
                if (lp.innerHTML !== html) lp.innerHTML = html;
                pr.classList.add('bb-has-lp');
              } else if (lp) { lp.remove(); pr.classList.remove('bb-has-lp'); }
            }
            if (a && a.dataset.bbFull && a.textContent.trim() !== shortName(a.dataset.bbFull)) a.textContent = shortName(a.dataset.bbFull);
            var v = li.querySelector('.rebuy-cart__flyout-item-variant-title');
            if (v && a) {
              if (!v.dataset.bbRaw) v.dataset.bbRaw = v.textContent.trim();
              var parts = v.dataset.bbRaw.split(' / ');
              var g = garment(a.dataset.bbFull || '');
              var txt = (g ? g + ' · ' : '') + parts.join(' · ');
              if (v.textContent.trim() !== txt) v.textContent = txt;
              var size = parts[parts.length - 1]; sizes[size] = (sizes[size] || 0) + qty;
            }
          });
          // title
          var title = root.querySelector('.rebuy-cart__title');
          if (title) { var tt = 'Your cart (' + count + ')'; if (title.textContent.trim() !== tt) title.textContent = tt; }
          // progress: headline with what she'd gain, milestone bar, gift card chip
          var pb = root.querySelector('[data-rebuy-component=progress-bar]');
          if (pb) {
            var fin0 = root.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
            var subtotal = fin0 ? num(fin0.textContent) : 0;
            var tiers = [[2, 5, '5% off', ''], [3, 10, '10% off', '+ free shipping'], [4, 15, '15% off', '+ free shipping']];
            var cur = count >= 4 ? 15 : count >= 3 ? 10 : count >= 2 ? 5 : 0;
            var next = null; tiers.forEach(function (t) { if (!next && count < t[0]) next = t; });
            var gift = count > 0 && subtotal > 20;
            var head, sub = '';
            if (!next) {
              head = 'You unlocked our best deal: 15% off + free shipping';
              sub = gift ? 'Plus your <b class="bb-g">$50 gift card</b>. That’s the most you can save on this order.' : 'You’re getting the most you can save on this order.';
            } else {
              var need = next[0] - count;
              head = need + ' more item' + (need > 1 ? 's' : '') + ' to ' + next[2] + (next[3] && count < 3 ? ' ' + next[3] : '');
              var got = [];
              if (gift) got.push('a <b class="bb-g">$50 gift card</b>');
              if (cur) got.push(cur + '% off');
              if (got.length) sub = 'You’ve already earned ' + got.join(' and ') + '. ';
              if (count > 0) {
                sub += 'Add ' + need + ' more and get <strong>' + next[1] + '% off everything</strong> in your cart' + (next[0] >= 3 && count < 3 ? ', plus free shipping' : '') + '.';
              }
            }
            var pct = Math.min(100, Math.max(0, (count - 1) / 3 * 100));
            var marks = (gift ? '<div class="bb-ms gift done" style="left:0%"><span class="bb-ms__dot">$50</span><span class="bb-ms__lab">Gift card<small>earned</small></span></div>' : '') +
              tiers.map(function (t, i) {
              var done = count >= t[0], isNext = next && next[0] === t[0];
              return '<div class="bb-ms' + (done ? ' done' : '') + (isNext ? ' next' : '') + '" style="left:' + ((t[0] - 1) / 3 * 100) + '%">' +
                '<span class="bb-ms__dot">' + (done ? CHECK : t[1] + '%') + '</span>' +
                '<span class="bb-ms__lab">' + t[2] + (t[3] ? '<small>+ free ship</small>' : '') + '</span></div>';
            }).join('');
            var html = '<div class="bb-prog__head">' + head + '</div>' + (sub ? '<div class="bb-prog__sub">' + sub + '</div>' : '') +
              '<div class="bb-prog__track' + (gift ? ' has-gift' : '') + '"><div class="bb-prog__fill" style="width:' + pct + '%"></div>' + marks + '</div>';
            var box = pb.querySelector('.bb-prog');
            if (!box) { box = document.createElement('div'); box.className = 'bb-prog'; pb.appendChild(box); }
            if (box.innerHTML !== html) box.innerHTML = html;
          }
          // gift card as its own line above the items (display only; the card is emailed after the order)
          var ci = root.querySelector('[data-rebuy-component=cart-items]');
          var fin1 = root.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
          var hasGift = count > 0 && fin1 && num(fin1.textContent) > 20;
          var gEl = ci && ci.querySelector('.bb-giftitem');
          if (ci && hasGift && !gEl) {
            gEl = document.createElement('div'); gEl.className = 'bb-giftitem';
            gEl.innerHTML = '<div class="bb-giftitem__card"><span>Brooke &amp; Belle</span><b>$50</b></div>' +
              '<div class="bb-giftitem__body"><div class="bb-giftitem__name">$50 Gift Card</div>' +
              '<div class="bb-giftitem__note">You’ve earned this because your order is over $20. We email it after you order. Use it on your next order of $100+.</div>' +
              '<div class="bb-giftitem__row"><span class="bb-giftitem__ok">' + CHECK + 'Earned</span><span class="bb-giftitem__price"><b>FREE</b><s>$50.00</s></span></div></div>';
            ci.insertBefore(gEl, ci.firstChild);
          } else if (gEl && !hasGift) { gEl.remove(); }
          // upsell heading + default size = the size already in her cart
          var w = root.querySelector('[data-rebuy-component=cross-sell-widget]');
          if (w) {
            var h = w.querySelector('.primary-title');
            var ut = count >= 4 ? 'You might also love' : 'Add 1 more for ' + (count >= 3 ? '15%' : count >= 2 ? '10%' : '5%') + ' off';
            if (h && h.textContent.trim() !== ut) h.innerHTML = '<b>' + ut + '</b>';
            if (h && !w.querySelector('.bb-upsell-sub')) { var p = document.createElement('p'); p.className = 'bb-upsell-sub'; p.textContent = 'Picked to go with what’s in your cart'; h.after(p); }
            var top = Object.keys(sizes).sort(function (x, y) { return sizes[y] - sizes[x]; })[0];
            w.querySelectorAll('.rebuy-product-block').forEach(function (blk) {
              var t = blk.querySelector('.rebuy-product-title');
              if (t) { if (!t.dataset.bbFull) t.dataset.bbFull = t.textContent.trim(); var sn = shortName(t.dataset.bbFull); if (t.textContent.trim() !== sn) t.textContent = sn; }
              var acts = blk.querySelector('.rebuy-product-actions');
              if (acts && !blk.querySelector('.bb-qty')) {
                var q = document.createElement('div'); q.className = 'bb-qty'; q.dataset.n = '1';
                q.innerHTML = '<button type="button" class="bb-qty__b" data-d="-1" aria-label="One fewer">−</button><span class="bb-qty__n" aria-live="polite">1</span><button type="button" class="bb-qty__b" data-d="1" aria-label="One more">+</button>';
                acts.parentNode.insertBefore(q, acts);
              }
              var b = blk.querySelector('.rebuy-product-actions .rebuy-button b');
              if (b && b.textContent.trim() !== '+ Add') b.textContent = '+ Add';
              var sel = blk.querySelector('select.variant-select');
              if (sel && top && !sel.dataset.bbSized) {
                var opt = Array.prototype.find.call(sel.options, function (o) { return o.text.trim() === top && !o.disabled; });
                sel.dataset.bbSized = '1';
                if (opt && sel.value !== opt.value) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
              }
            });
          }
          // footer: savings, gift card line, checkout label, guarantee
          var fin = root.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
          var cmp = root.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');
          var total = fin ? num(fin.textContent) : 0, was = cmp ? num(cmp.textContent) : 0;
          var sav = root.querySelector('.cart-savings-amount');
          if (sav) { var sh = was > total ? '<span>You’re saving</span><span>' + money(was - total) + '</span>' : ''; if (sav.innerHTML !== sh) sav.innerHTML = sh; }
          var st = root.querySelector('[data-rebuy-component=cart-subtotal]');
          var co = root.querySelector('.rebuy-cart__checkout-button');
          // gift card reminder right above Checkout: its own line, never in the savings number, $100+ condition on the same line
          var gl = root.querySelector('.bb-giftline');
          if (count > 0 && total > 20 && co) {
            if (!gl) { gl = document.createElement('div'); gl.className = 'bb-giftline'; gl.innerHTML = GIFT + '<span><strong>Plus a FREE $50 gift card</strong> for your next order of $100+.</span>'; }
            if (co.previousElementSibling !== gl) co.before(gl);
          } else if (gl) { gl.remove(); }
          if (co) {
            var lab = LOCK + '<span>Checkout · ' + money(total) + '</span>';
            var s = co.querySelector('.bb-co');
            if (!s) { s = document.createElement('span'); s.className = 'bb-co'; co.appendChild(s); }
            if (s.innerHTML !== lab) s.innerHTML = lab;
            var area = co.parentNode;
            if (area && !area.querySelector('.bb-guarantee-line')) { var gd = document.createElement('div'); gd.className = 'bb-guarantee-line'; gd.innerHTML = SHIELD + '<span>Extended money-back guarantee. Less than 1% of customers use it.</span>'; co.after(gd); }
          }
        } catch (e) { console.warn('bb cart', e); }
        busy = false;
      }
      var t;
      function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
      var tries = 0;
      (function attach() {
        var root = document.getElementById('rebuy-cart');
        if (!root) { if (tries++ < 120) setTimeout(attach, 500); return; }
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true, characterData: true });
        apply();
      })();
      // quantity steppers on the suggestion cards
      var pendingQty = 0;
      document.addEventListener('click', function (ev) {
        var sb = ev.target.closest && ev.target.closest('#rebuy-cart .bb-qty__b');
        if (sb) {
          ev.preventDefault(); ev.stopPropagation();
          var q = sb.closest('.bb-qty'); var n = Math.max(1, Math.min(10, (parseInt(q.dataset.n, 10) || 1) + parseInt(sb.dataset.d, 10)));
          q.dataset.n = String(n); q.querySelector('.bb-qty__n').textContent = n;
          return;
        }
        var ab = ev.target.closest && ev.target.closest('#rebuy-cart .rebuy-product-actions .rebuy-button');
        if (ab) {
          var qq = ab.closest('.rebuy-product-block') && ab.closest('.rebuy-product-block').querySelector('.bb-qty');
          pendingQty = qq ? (parseInt(qq.dataset.n, 10) || 1) : 1;
          if (qq) { qq.dataset.n = '1'; qq.querySelector('.bb-qty__n').textContent = '1'; }
        }
      }, true);
      function onAdd(e) {
        var extra = pendingQty - 1; pendingQty = 0;
        var prod = e && e.detail && e.detail.product;
        var vid = prod && prod.selected_variant && prod.selected_variant.id;
        if (extra > 0 && vid) {
          var want = extra + 1;
          setTimeout(function () {
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var line = (c.items || []).filter(function (i) { return i.variant_id === vid; })[0];
              if (!line) return;
              return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity - 1 + want }) });
            }).then(function () { if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.fetchCart) Rebuy.Cart.fetchCart(); });
          }, 400);
        }
      }
      document.addEventListener('rebuy.add', onAdd);
      document.addEventListener('rebuy:widget.add', onAdd);
      document.addEventListener('rebuy:cart.change', schedule);
      document.addEventListener('rebuy:smartcart.show', schedule);
    })();
    
    return true;
  }
  var n = 0;
  (function wait() { if (go() === false && n++ < 60) setTimeout(wait, 500); })();
})();
